import { useImperativeHandle, useState } from 'react';
import Swal from 'sweetalert2';

function Search({ getOrganizations, setIsSearched, formRef }) {

const [search, setSearch] = useState('');
const [option, setOption] = useState('');

useImperativeHandle(formRef, () => ({
    reset: () => {
        setOption('');
        setSearch('');
    }
}));

const showError = (message) => {
    Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: message,
    });
};

const handleSubmit = (e) => {
    e.preventDefault();

    if (!option) {
        return showError('Seleccione una opción de búsqueda');
    }

    if (!search.trim()) {
        return showError('Escriba un valor para buscar');
    }

    getOrganizations({
        page: 1,
        [option]: search.trim()
    });

    setIsSearched({
        option,
        search,
        state: true
    });
};

return (
    <div>
        <div className="row mb-2">
            <h6>Busqueda de Organizaciones</h6>
        </div>

        <div
            className="table-responsive rounded-3 d-flex justify-content-center"
            style={{ border: '1px solid black', padding: '15px' }}
        >
            <form className="row g-3" onSubmit={handleSubmit}>

                <div className="col-auto">
                    <select
                        className="form-select"
                        value={option}
                        onChange={(e) => setOption(e.target.value)}
                    >
                        <option value="">Seleccione</option>
                        <option value="nit">NIT</option>
                        <option value="razonSocial">Razón Social</option>
                    </select>
                </div>

                <div className="col-auto">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Escriba su búsqueda..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>

                <div className="col-auto">
                    <button type="submit" className="btn btn-primary">
                        Buscar
                    </button>
                </div>

            </form>
        </div>
    </div>
);

}

export default Search;